// extracted by mini-css-extract-plugin
export default {"footer":"APq9JZHy2O_kproEowpl"};